import React, { useEffect } from "react";
import ReactGA from "react-ga4";

import preAssembleia from "../../../assets/landingpage/unicred/pre-assembleia.png";
import iconDownload from "../../../assets/landingpage/unicred/download.png";
import iconInstagram from "../../../assets/landingpage/unicred/instagram.png";
import iconFacebook from "../../../assets/landingpage/unicred/facebook.png";
import iconTwitter from "../../../assets/landingpage/unicred/twitter.png";
import iconYoutube from "../../../assets/landingpage/unicred/youtube.png";
import iconLinkedin from "../../../assets/landingpage/unicred/linkedin.png";
import iconWhatsapp from "../../../assets/landingpage/unicred/whatsapp.png";
import unicredLogo from "../../../assets/landingpage/unicred/unicred.png";

import "./styles.scss";

function UnicredVale({ domain }) {
  useEffect(() => {
    ReactGA.send({
      hitType: "event",
      eventCategory: "landingPage",
      eventAction: "access",
      eventLabel: domain,
    });
  }, []);

  return (
    <div className="lp-unicred">
      <div className="section-1">
        <div className="section-1-container wrap">
          <div className="section-1-image">
            <div className="section-1-position">
              <img src={preAssembleia} />
            </div>
          </div>
          <div className="section-1-info section-1-info-custom section-1-info-custom-uniao">
            <div className="section-1-info-title section-1-info-title-custom">
              <h2>PRÉ-ASSEMBLEIA</h2>
              <h3>UNICRED VALE 2026</h3>
            </div>

            <p>
              Boas-vindas!<br />
              Sua participação é importante para fortalecer a Unicred Vale e assegurar decisões que atendam aos interesses da cooperativa e dos cooperados.<br />
              Aqui, você fica por dentro do essencial para chegar bem-informado à Assembleia Geral Ordinária (AGO). 
            </p>
            <p>
              <strong>ANOTE NA AGENDA</strong><br />
              Participe da Assembleia Geral Ordinária (AGO) no dia 30 de março de 2026, com transmissão pelo aplicativo Unicred Mobile ou pelo site da Unicred Vale.
            </p>
            <p>
              Abertura às 10h.<br />
              Retomada do evento às 19h30.<br />
              (Horário de Brasília)
            </p>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo">
        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title">Palavra do<span> Presidente</span></h1>
            <p>Assista ao vídeo do Dr. Wálmore Pereira de Siqueira Júnior.</p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-palavras-do-presidente.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo" style={{ backgroundColor: '#332f2a' }}>
        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title" style={{ fontSize: 52 }}>CONFIRA AS<span> REALIZAÇÕES DE 2025</span></h1>
            <p>Veja um resumo dos destaques do ano. Sua participação foi fundamental para os resultados alcançados.</p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-realizacoes-2025.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo">
        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title" style={{ fontSize: 52 }}>VEJA AS<span> DEMONSTRAÇÕES CONTÁBEIS</span></h1>
            <p>Acompanhe a apresentação dos números da cooperativa com o diretor de operações, Rafael Peters Pereira.</p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-balanco-financeiro.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo" style={{ backgroundColor: '#332f2a' }}>
        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title" style={{ fontSize: 52 }}>VISÃO PARA O<span> NOSSO FUTURO</span></h1>
            <p style={{ fontSize: 22, marginBottom: 20 }}>Em 2026 tem eleição para o Conselho de Administração. <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-proposta-de-trabalho-chapa-renovacao-estrategica.pdf" target="_blank">Clique</a> para conhecer as propostas da chapa inscrita.</p>
            <p style={{ fontSize: 22 }}>
              Agradecemos por fazer parte deste momento.<br />
              Com a sua participação, seguimos fortalecendo a Unicred Vale e construindo um futuro ainda mais sólido. 
            </p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-chapa-renovacao-estrategica.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-links" style={{ backgroundColor: "#3d3935" }}>
        <div className="section-links-container section-links-container-uniao wrap">
          <div>
            <ul className="links2" style={{ maxWidth: "100%" }}>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-edital.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Edital
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-estatuto-social.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Estatuto Social
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-divulgacao-de-chapas-inscritas-eleicao-do-conselho-de-administracao-2026.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Divulgação de Chapas inscritas - Eleição do Conselho de Administração 2026
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-proposta-de-trabalho-chapa-renovacao-estrategica.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Proposta de Trabalho - Chapa Renovação Estratégica
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-calendario-eleitoral-eleicoes-do-ca.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Calendário Eleitoral - Eleições do CA
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-regimento-eleitoral.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Regimento Eleitoral
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-proposta-de-regulamento-do-fundo-de-expansao.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Proposta de Regulamento do Fundo de Expansão
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-vale-politica-de-remuneracao-dos-administradores.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política de Remuneração dos Administradores
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/manual-unicred-web.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso computador
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/manual-unicred-mobile.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso celular
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-container wrap">
          <div className="footer-info">
            <a className="footer-info-site" href="https://unicred.com.br" target="_blank">unicred.com.br</a>

            <div className="footer-info-box">
              <h2 style={{ marginBottom: 0 }}>Central de Relacionamento Unicred</h2>
              <h2>24 horas por dia, 7 dias por semana</h2>
              <p>3003 7703 (Capitais e Regiões Metropolitanas)</p>
              <p>0800 200 7302 (Demais Localidades)</p>
              <p>+55 800 200 7302 (WhatsApp)</p>
              <p>+55 11 3003 7703 (Ligações do Exterior)</p>
              <p>Chat no app Unicred Mobile e Internet Banking</p>
            </div>

            <div className="footer-info-box">
              <h2>SAC</h2>
              <p>0800 647 2930</p>
            </div>

            <div className="footer-info-box">
              <h2>Ouvidoria</h2>
              <p>0800 940 0602</p>
            </div>
          </div>

          <div className="footer-social">
            <div className="footer-social-box">
              <h2>Siga a Unicred nas redes sociais</h2>
              <ul className="social-list">
                <li><a href="https://www.instagram.com/unicredbrasil/" title="Instagram" target="_blank"><img src={iconInstagram} alt="Instagram" /></a></li>
                <li><a href="https://www.facebook.com/unicredbrasil" title="Facebook" target="_blank"><img src={iconFacebook} alt="Facebook" /></a></li>
                <li><a href="https://twitter.com/unicredbrasil" title="Twitter" target="_blank"><img src={iconTwitter} alt="Twitter" /></a></li>
                <li><a href="https://www.youtube.com/channel/UCdowVMAIRENRC2VH0_gcdww" title="Youtube" target="_blank"><img src={iconYoutube} alt="Youtube" /></a></li>
                <li><a href="https://br.linkedin.com/company/unicredbr" title="Linkedin" target="_blank"><img src={iconLinkedin} alt="Linkedin" /></a></li>
              </ul>
            </div>

            <div className="footer-logo">
              <img src={unicredLogo} alt="Unicred" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnicredVale;
